import React, { useEffect, useState, useMemo } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useLocation } from 'react-router';
import { CALCS_PER_PAGE, CALC_NAMES, CALC_PAGE_TYPES } from 'utils/calculatorUtils';
import CalcAccordion from '../../components/CalcAccordion/CalcAccordion';
import CalcIcon from '../../components/CalcIcon/CalcIcon';
import CalcFilter from '../../components/CalcFilter/CalcFilter';
import CalcAssessment from '../../components/CalcAssessment/CalcAssessment';
import CalcEmptyListBlock from '../../components/CalcEmptyListBlock/CalcEmptyListBlock';
import CustomResult from '../../components/ByType/CustomReport/ResultListElement/ReportResult';
import GhgResult from '../../components/ByType/GhgReport/ReportResult/ReportResult';
import { getResult as getReportResult } from 'api/reports/endpoints/reports';
import { Loader } from 'tt-ui-lib/core';
import { useSelectedContext } from 'context/contextSelector';

const Results = ({ targetWidth, pageType }) => {
  const { selectedCompany: widjetCompany } = useSelectedContext((context) => context.user);
  const types = CALCS_PER_PAGE[pageType];
  const { pathname } = useLocation();
  const [searchedAssessments, setSearchedAssessments] = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);

  const RenewReportResultList = () => {
    setLoading(true);
    getReportResult({ pageType, f: true })
      .then((resp) => {
        const { data, success } = resp?.data ?? {};
        if (success) setAssessments(data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    RenewReportResultList();
  }, [pathname]);

  const companyAssessments =
    widjetCompany && widjetCompany.selectedCompany
      ? assessments.filter((el) => el.companyId === widjetCompany.selectedCompany.id)
      : assessments;

  return (
    <>
      {companyAssessments.length > 0 ? (
        <>
          <CalcFilter setSearchedItems={setSearchedAssessments} items={companyAssessments} />
          {types.map((type) => (
            <>
              {searchedAssessments.some((asses) => asses.type === type) && (
                <div key={type}>
                  <CalcAccordion logo={<CalcIcon type={type} />} title={CALC_NAMES[type]}>
                    {searchedAssessments
                      .filter((assessment) => assessment.type === type)
                      .map((assessment) => (
                        <div key={assessment.id}>
                          {pageType === CALC_PAGE_TYPES.CUSTOM && (
                            <CustomResult targetWidth={targetWidth} assessment={assessment} />
                          )}
                          {pageType === CALC_PAGE_TYPES.SUSTAINABILITY && (
                            <GhgResult
                              targetWidth={targetWidth}
                              assessment={assessment}
                              refresh={RenewReportResultList}
                            />
                          )}
                        </div>
                      ))}
                  </CalcAccordion>
                </div>
              )}
            </>
          ))}
        </>
      ) : loading ? (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <Loader />
        </div>
      ) : (
        <CalcEmptyListBlock collectionName="results" />
      )}
    </>
  );
};

export default Results;
